<template>
  <v-container class="px-0 py-10">
    <app-loading :loading="loading">
      <div>
        <app-header :backAction="backAction" backButton :button="false">
          <template #title> Custom Homework </template>
        </app-header>
        <app-homework :active="step === 6" :filterFields="{ not_speak: undefined }" />
      </div>
    </app-loading>
  </v-container>
</template>
<script>
import Loading from "@/components/Loading.vue";
import directionMixin from "@/mixins/directionMixin";
import { getConclusion, getLessonProgressById } from "@/api/api";
import Homework from "./Homework/Homework.vue";
import Header from "../Header.vue";

export default {
  components: {
    appLoading: Loading,
    appHomework: Homework,
    appHeader: Header,
  },
  mixins: [directionMixin],
  data() {
    return {
      data: {},
      loading: false,
      loadingProgress: false,
      progress: this.$store.getters["progress/lesson"],
      completedText: "Uncheck Lesson as Completed",
      icon: "mdi-decagram",
    };
  },
  computed: {
    step: (vm) => {
      return vm.$store.getters["lesson/step"];
    },
    lessonType: (vm) => {
      if (vm.$route.name === "practice") {
        return "Lesson Practice";
      } else return "Live Lesson";
    },
  },
  async created() {
    this.loading = true;
    const response = await getConclusion(this.source.conclusion_step, this.direction);
    this.data = response.data;
    this.completedText = this.getCompletedText();
    this.loading = false;
  },
  watch: {
    async step(value) {
      if (value === 5) {
        const response = await getLessonProgressById(this.$store.getters["progress/lesson"].uuid);
        this.progress = response.data;
      }
    },
  },
  methods: {
    getCompletedText() {
      if (this.lessonType === "Lesson Practice") {
        if (this.progress.practice_progress.completed) {
          this.icon = "mdi-check-decagram";
        } else this.icon = "mdi-decagram";
        if (this.progress.practice_progress.completed)
          return "Uncheck " + this.lessonType + " as Completed";
        else return "Check " + this.lessonType + " as Completed";
      }
      if (this.progress.teach_progress.completed) {
        this.icon = "mdi-check-decagram";
      } else this.icon = "mdi-decagram";

      if (this.progress.teach_progress.completed)
        return "Uncheck " + this.lessonType + " as Completed";
      else return "Check " + this.lessonType + " as Completed";
    },
    // async onClick() {
    //   this.loadingProgress = true;
    //   let body = JSON.parse(JSON.stringify(this.progress));
    //   if (this.lessonType === 'Lesson Practice') {
    //     body.practice_progress.completed = !this.progress.practice_progress
    //       .completed;
    //   } else {
    //     body.teach_progress.completed = !this.progress.teach_progress.completed;
    //   }
    //   const response = await patchLessonProgress(body);
    //   if (response) {
    //     this.progress = response.data;
    //     this.$store.commit('progress/lesson', response.data);
    //     this.completedText = this.getCompletedText();
    //   }
    //   this.loadingProgress = false;
    // },
    backAction() {
      this.$emit("prev-step");
    },
  },
};
</script>
